import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  FaArrowLeft,
  FaMedal,
  FaUsers,
  FaShieldAlt,
  FaHeartbeat,
  FaDumbbell,
  FaSwimmer,
  FaTableTennis,
  FaCoffee,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  FaYoutube,
  FaQuoteLeft,
  FaQuoteRight,
  FaHandshake,
  FaBuilding,
  FaBaseballBall
} from 'react-icons/fa';

import {
  GiCricket,
  GiTennisRacket,
  GiEightBall,
  GiShuttlecock,
  GiWhistle,
  GiTargetPrize
} from 'react-icons/gi';


/* ============================================================
   IMAGE IMPORTS
   ============================================================ */

import sportsLogo from '../logos/sportsarena/sportarenalogo.png';
import heroImage from '../logos/sportsarena/sportarena1.png';
import cricketImage from '../logos/sportsarena/sportarena2.png';
import padelImage from '../logos/sportsarena/sportarena3.png';


/* ============================================================
   MAIN COMPONENT
   ============================================================ */

export default function RHSportsArena() {

  const navigate = useNavigate();

  return (
    <div style={styles.page}>

      {/* ======================================================
          BACK NAVIGATION
          ====================================================== */}

      <div style={styles.topNav}>

        <button
          style={styles.backButton}
          onClick={() => navigate('/')}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform =
              'translateX(-5px) translateY(-2px)';
            e.currentTarget.style.backgroundColor = '#0756a5';
            e.currentTarget.style.boxShadow =
              '0 10px 25px rgba(0,0,0,0.28)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform =
              'translateX(0) translateY(0)';
            e.currentTarget.style.backgroundColor = '#0b2545';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          <FaArrowLeft />

          <span>
            Back to All Sectors
          </span>
        </button>

      </div>


      {/* ======================================================
          WEBSITE
          ====================================================== */}

      <main style={styles.website}>


        {/* ====================================================
            HERO SECTION
            ==================================================== */}

        <section
          style={styles.heroSection}
          className="rh-hero-section"
        >

          {/* ==================================================
              LEFT HERO
              ================================================== */}

          <div
            style={styles.heroLeft}
            className="rh-hero-left"
          >

            {/* SPORTS ARENA LOGO */}

            <div
              style={styles.logoArea}
              className="rh-logo-area"
            >

              <img
                src={sportsLogo}
                alt="Sports Arena Logo"
                style={styles.sportsLogoImage}
                className="rh-sports-logo"
              />

            </div>


            {/* HERO CONTENT */}

            <div
              style={styles.heroLeftContent}
              className="rh-hero-left-content"
            >

              <div className="rh-small-label">
                RH SPORTS ARENA
              </div>

              <h1 style={styles.heroHeadline}>
                PLAY. TRAIN. RELAX.
              </h1>

              <h2 style={styles.heroHeadlineBlue}>
                ALL UNDER ONE ROOF.
              </h2>

              <div
                style={styles.shortLine}
                className="rh-short-line"
              />

              <p style={styles.heroDescription}>
                RH Sports Arena is Gujranwala's premium
                sports &amp; recreation destination. A place
                designed to promote a healthy lifestyle,
                build champions, and create unforgettable
                experiences for all ages.
              </p>

              <div
                className="rh-hero-badges"
              >

                <span>
                  SPORTS
                </span>

                <span>
                  FITNESS
                </span>

                <span>
                  COMMUNITY
                </span>

              </div>

            </div>

          </div>


          {/* ==================================================
              RIGHT HERO IMAGE
              ================================================== */}

          <div
            style={styles.heroRight}
            className="rh-hero-right"
          >

            <img
              src={heroImage}
              alt="RH Sports Arena"
              style={styles.heroImage}
              className="rh-hero-image"
            />

            <div
              style={styles.heroDarkOverlay}
              className="rh-hero-overlay"
            />


            {/* DECORATIVE ELEMENT */}

            <div className="rh-hero-glow"></div>

            <div className="rh-hero-corner"></div>


            {/* HERO TEXT */}

            <div
              style={styles.heroTextOverlay}
              className="rh-hero-text"
            >

              <div className="rh-hero-overline">
                PREMIUM SPORTS EXPERIENCE
              </div>

              <h2 style={styles.heroOverlayTitle}>

                WHERE PASSION

                <br />

                <span style={styles.heroOverlayBlue}>
                  MEETS PERFORMANCE
                </span>

              </h2>

              <div
                style={styles.overlayLine}
                className="rh-overlay-line"
              />

              <p style={styles.heroOverlaySubtitle}>

                A PREMIUM ARENA FOR

                <br />

                CHAMPIONS &amp; COMMUNITIES

              </p>

            </div>


            {/* HERO FEATURE BAR */}

            <div
              style={styles.heroFeatureBar}
              className="rh-hero-feature-bar"
            >

              <HeroFeature
                icon={<FaMedal />}
                text={
                  <>
                    PREMIUM
                    <br />
                    FACILITIES
                  </>
                }
              />

              <HeroFeature
                icon={<FaUsers />}
                text={
                  <>
                    FOR ALL AGES
                    <br />
                    &amp; SKILL LEVELS
                  </>
                }
              />

              <HeroFeature
                icon={<FaShieldAlt />}
                text={
                  <>
                    SAFE, SECURE
                    <br />
                    &amp; WELL MAINTAINED
                  </>
                }
              />

              <HeroFeature
                icon={<FaHeartbeat />}
                text={
                  <>
                    FITNESS &amp; FUN
                    <br />
                    TOGETHER
                  </>
                }
              />

            </div>

          </div>

        </section>


        {/* ====================================================
            CURRENT + COMING SOON
            ==================================================== */}

        <section style={styles.facilitiesSection}>

          {/* ==================================================
              CURRENT FACILITIES
              ================================================== */}

          <div
            style={styles.currentFacilities}
            className="rh-current-facilities"
          >

            <div
              style={styles.sectionRibbon}
              className="rh-section-ribbon"
            >
              OUR CURRENT FACILITIES
            </div>


            <div
              style={styles.facilityCards}
              className="rh-facility-cards"
            >

              {/* CRICKET */}

              <div
                style={styles.facilityCard}
                className="rh-facility-card"
              >

                <div
                  style={styles.facilityImageArea}
                  className="rh-facility-image-area"
                >

                  <img
                    src={cricketImage}
                    alt="Cage Cricket"
                    style={styles.facilityImage}
                    className="rh-facility-image"
                  />

                  <div className="rh-image-shine"></div>

                  <div
                    style={styles.facilityIcon}
                    className="rh-facility-icon"
                  >
                    <GiCricket />
                  </div>

                  <div className="rh-card-label">
                    ACTIVE NOW
                  </div>

                </div>


                <div style={styles.facilityContent}>

                  <h3 style={styles.facilityTitle}>
                    CAGE CRICKET
                  </h3>

                  <p style={styles.facilityDescription}>
                    International standard cage cricket
                    turf with top-quality nets, excellent
                    lighting, and a great playing experience.
                  </p>

                  <div className="rh-card-bottom">
                    <span>
                      PLAY • TRAIN • COMPETE
                    </span>

                    <span className="rh-card-arrow">
                      →
                    </span>
                  </div>

                </div>

              </div>


              {/* PADEL */}

              <div
                style={styles.facilityCard}
                className="rh-facility-card"
              >

                <div
                  style={styles.facilityImageArea}
                  className="rh-facility-image-area"
                >

                  <img
                    src={padelImage}
                    alt="Padel Court"
                    style={styles.facilityImage}
                    className="rh-facility-image"
                  />

                  <div className="rh-image-shine"></div>

                  <div
                    style={styles.facilityIcon}
                    className="rh-facility-icon"
                  >
                    <GiTennisRacket />
                  </div>

                  <div className="rh-card-label">
                    ACTIVE NOW
                  </div>

                </div>


                <div style={styles.facilityContent}>

                  <h3 style={styles.facilityTitle}>
                    PADEL COURT
                  </h3>

                  <p style={styles.facilityDescription}>
                    Experience the fastest growing sport
                    in the world. Our premium padel court
                    is perfect for beginners and professionals.
                  </p>

                  <div className="rh-card-bottom">
                    <span>
                      PLAY • TRAIN • COMPETE
                    </span>

                    <span className="rh-card-arrow">
                      →
                    </span>
                  </div>

                </div>

              </div>

            </div>

          </div>


          {/* ==================================================
              MORE FACILITIES
              ================================================== */}

          <div
            style={styles.moreFacilities}
            className="rh-more-facilities"
          >

            <div style={styles.moreHeader}>

              <div style={styles.headerLine}></div>

              <span>
                MORE FACILITIES
              </span>

              <div style={styles.headerLine}></div>

            </div>


            <h2 style={styles.comingSoon}>
              COMING SOON
            </h2>


            <p className="rh-coming-description">
              More ways to move, compete and connect.
            </p>


            <div
              style={styles.moreGrid}
              className="rh-more-grid"
            >

              <ComingSoonItem
                icon={<FaDumbbell />}
                title={
                  <>
                    GYM &
                    <br />
                    FITNESS
                  </>
                }
              />

              <ComingSoonItem
                icon={<GiShuttlecock />}
                title={
                  <>
                    INDOOR
                    <br />
                    BADMINTON COURT
                  </>
                }
              />

              <ComingSoonItem
                icon={<FaSwimmer />}
                title={
                  <>
                    SWIMMING
                    <br />
                    POOL
                  </>
                }
              />

              <ComingSoonItem
                icon={<FaTableTennis />}
                title={
                  <>
                    TABLE
                    <br />
                    TENNIS
                  </>
                }
              />

              <ComingSoonItem
                icon={<GiEightBall />}
                title="SNOOKER"
              />

              <ComingSoonItem
                icon={<FaCoffee />}
                title={
                  <>
                    CAFE
                    <br />
                    LOUNGE
                  </>
                }
              />

            </div>

          </div>

        </section>


        {/* ====================================================
            WHY CHOOSE
            ==================================================== */}

        <section
          style={styles.whySection}
          className="rh-why-section"
        >

          <div
            style={styles.whyLeft}
            className="rh-why-left"
          >

            <div className="rh-section-mini-title">
              THE RH DIFFERENCE
            </div>

            <h2 style={styles.whyTitle}>
              WHY CHOOSE RH SPORTS ARENA?
            </h2>


            <div
              style={styles.whyItems}
              className="rh-why-items"
            >

              <WhyItem
                icon={<FaBuilding />}
                text={
                  <>
                    State-of-the-art
                    <br />
                    Infrastructure
                  </>
                }
              />

              <WhyItem
                icon={<FaShieldAlt />}
                text={
                  <>
                    Hygienic &
                    <br />
                    Well Maintained
                  </>
                }
              />

              <WhyItem
                icon={<FaMedal />}
                text={
                  <>
                    Affordable
                    <br />
                    Membership Plans
                  </>
                }
              />

              <WhyItem
                icon={<GiWhistle />}
                text={
                  <>
                    Coaching &amp; Training
                    <br />
                    Programs
                  </>
                }
              />

              <WhyItem
                icon={<GiTargetPrize />}
                text={
                  <>
                    Events &amp; Tournaments
                    <br />
                    &amp; Much More
                  </>
                }
              />

            </div>

          </div>


          {/* QUOTE */}

          <div
            style={styles.quoteBox}
            className="rh-quote-box"
          >

            <FaQuoteLeft
              style={styles.quoteLeft}
              className="rh-quote-icon"
            />

            <p style={styles.quoteText}>

              We are building more than a sports arena –
              we are building a community that lives healthy,
              plays together, and grows stronger.

            </p>

            <FaQuoteRight
              style={styles.quoteRight}
              className="rh-quote-icon"
            />

          </div>

        </section>


        {/* ====================================================
            VISIT US
            ==================================================== */}

        <section
          style={styles.visitSection}
          className="rh-visit-section"
        >

          {/* LOCATION */}

          <div
            style={styles.visitBox}
            className="rh-visit-box"
          >

            <div
              style={styles.locationCircle}
              className="rh-location"
            >
              <FaMapMarkerAlt />
            </div>

            <div>

              <h3 style={styles.visitTitle}>
                VISIT US TODAY!
              </h3>

              <p style={styles.visitText}>

                RH SPORTS ARENA

                <br />

                Gujranwala, Pakistan

              </p>

            </div>

          </div>


          {/* CENTER */}

          <div
            style={styles.visitCenter}
            className="rh-visit-center"
          >

            <span style={styles.visitCenterSmall}>
              ONE ARENA. ENDLESS POSSIBILITIES.
            </span>

            <h2 style={styles.visitCenterTitle}>
              COME. PLAY. BELONG.
            </h2>

          </div>


          {/* SOCIAL */}

          <div
            style={styles.socialBox}
            className="rh-social-box"
          >

            <h3 style={styles.socialTitle}>
              FOLLOW US
            </h3>

            <div style={styles.socialIcons}>

              <SocialIcon icon={<FaFacebookF />} />

              <SocialIcon icon={<FaInstagram />} />

              <SocialIcon icon={<FaTiktok />} />

              <SocialIcon icon={<FaYoutube />} />

            </div>

            <span style={styles.socialHandle}>
              @rhsportsarena
            </span>

          </div>

        </section>


        {/* ====================================================
            FOOTER
            ==================================================== */}

        <footer
          style={styles.footer}
          className="rh-footer"
        >

          <div style={styles.footerNumber}>
            19
          </div>


          <div style={styles.footerCompany}>

            <h3 style={styles.footerCompanyTitle}>
              ASHRAF GROUP OF INDUSTRIES
            </h3>

            <p style={styles.footerCompanyTag}>
              Building Legacy. Powering the Future.
            </p>

          </div>


          <div
            style={styles.footerPillars}
            className="rh-footer-pillars"
          >

            <FooterPillar
              icon={<FaHeartbeat />}
              title={
                <>
                  HEALTHIER
                  <br />
                  LIFESTYLE
                </>
              }
            />

            <FooterPillar
              icon={<FaUsers />}
              title={
                <>
                  YOUTH
                  <br />
                  ENGAGEMENT
                </>
              }
            />

            <FooterPillar
              icon={<FaHandshake />}
              title={
                <>
                  COMMUNITY
                  <br />
                  BUILDING
                </>
              }
            />

            <FooterPillar
              icon={<FaBaseballBall />}
              title={
                <>
                  EXCELLENCE IN
                  <br />
                  RECREATION
                </>
              }
            />

            <FooterPillar
              icon={<FaShieldAlt />}
              title={
                <>
                  STRONGER
                  <br />
                  TOGETHER
                </>
              }
            />

          </div>

        </footer>

      </main>

    </div>
  );
}


/* ============================================================
   HERO FEATURE
   ============================================================ */

function HeroFeature({ icon, text }) {

  return (
    <div
      style={styles.heroFeature}
      className="rh-hero-feature"
    >

      <div className="rh-feature-icon">
        {icon}
      </div>

      <span>
        {text}
      </span>

    </div>
  );
}


/* ============================================================
   COMING SOON
   ============================================================ */

function ComingSoonItem({ icon, title }) {

  return (
    <div
      style={styles.comingItem}
      className="rh-coming-item"
    >

      <div
        style={styles.comingIcon}
        className="rh-coming-icon"
      >
        {icon}
      </div>

      <span>
        {title}
      </span>

      <div className="rh-coming-status">
        COMING SOON
      </div>

    </div>
  );
}


/* ============================================================
   WHY ITEM
   ============================================================ */

function WhyItem({ icon, text }) {

  return (
    <div
      style={styles.whyItem}
      className="rh-why-item"
    >

      <div
        style={styles.whyIcon}
        className="rh-why-icon"
      >
        {icon}
      </div>

      <span>
        {text}
      </span>

    </div>
  );
}


/* ============================================================
   SOCIAL ICON
   ============================================================ */

function SocialIcon({ icon }) {

  return (
    <div
      style={styles.socialIcon}
      className="rh-social-icon"
    >
      {icon}
    </div>
  );
}


/* ============================================================
   FOOTER PILLAR
   ============================================================ */

function FooterPillar({ icon, title }) {

  return (
    <div
      style={styles.footerPillar}
      className="rh-footer-pillar"
    >

      <div
        style={styles.footerPillarIcon}
        className="rh-footer-icon"
      >
        {icon}
      </div>

      <span>
        {title}
      </span>

    </div>
  );
}


/* ============================================================
   STYLES
   ============================================================ */

const styles = {

  /* ==========================================================
     PAGE
     ========================================================== */

  page: {
    width: '100%',
    minHeight: '100vh',
    margin: 0,
    padding: 0,
    backgroundColor: '#111a24',
    fontFamily: '"Helvetica Neue", Arial, sans-serif',
    color: '#1d2733',
    boxSizing: 'border-box',
    overflowX: 'hidden'
  },


  /* ==========================================================
     NAVIGATION
     ========================================================== */

  topNav: {
    width: '100%',
    padding: '15px 20px',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box'
  },

  backButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    border: 'none',
    backgroundColor: '#0b2545',
    color: '#ffffff',
    padding: '11px 18px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '700',
    transition: 'all 0.35s ease',
    boxShadow: 'none'
  },


  /* ==========================================================
     WEBSITE
     ========================================================== */

  website: {
    width: '100%',
    maxWidth: '1500px',
    margin: '0 auto',
    padding: 0,
    backgroundColor: '#ffffff',
    boxSizing: 'border-box',
    overflow: 'hidden',
    boxShadow: '0 20px 60px rgba(0,0,0,0.38)'
  },


  /* ==========================================================
     HERO
     ========================================================== */

  heroSection: {
    width: '100%',
    minHeight: '650px',
    display: 'flex',
    margin: 0,
    padding: 0,
    boxSizing: 'border-box'
  },

  heroLeft: {
    width: '38%',
    minHeight: '650px',
    backgroundColor: '#ffffff',
    padding: '55px 55px 45px 55px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
    zIndex: 2,
    overflow: 'hidden'
  },

  logoArea: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },

  sportsLogoImage: {
    width: '270px',
    maxWidth: '100%',
    height: 'auto',
    objectFit: 'contain',
    objectPosition: 'left center',
    display: 'block'
  },

  heroLeftContent: {
    marginTop: '40px'
  },

  heroHeadline: {
    margin: 0,
    fontSize: '38px',
    lineHeight: '1.05',
    fontWeight: '900',
    color: '#182333',
    letterSpacing: '-1px'
  },

  heroHeadlineBlue: {
    margin: '6px 0 0 0',
    fontSize: '38px',
    lineHeight: '1.05',
    fontWeight: '900',
    color: '#0756a5',
    letterSpacing: '-1px'
  },

  shortLine: {
    width: '65px',
    height: '3px',
    backgroundColor: '#0756a5',
    margin: '28px 0',
    transition: 'width 0.5s ease'
  },

  heroDescription: {
    maxWidth: '420px',
    margin: 0,
    fontSize: '17px',
    lineHeight: '1.65',
    color: '#3e4650'
  },


  /* ==========================================================
     HERO RIGHT
     ========================================================== */

  heroRight: {
    width: '62%',
    minHeight: '650px',
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: '#071c35'
  },

  heroImage: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
    transition: 'transform 1.5s cubic-bezier(.2,.8,.2,1)'
  },

  heroDarkOverlay: {
    position: 'absolute',
    inset: 0,
    background:
      'linear-gradient(135deg, rgba(2,17,34,0.88) 0%, rgba(2,17,34,0.34) 50%, rgba(2,17,34,0.60) 100%)',
    pointerEvents: 'none'
  },

  heroTextOverlay: {
    position: 'absolute',
    top: '65px',
    left: '70px',
    color: '#ffffff',
    zIndex: 3
  },

  heroOverlayTitle: {
    margin: 0,
    fontSize: '42px',
    lineHeight: '1.05',
    fontWeight: '900',
    letterSpacing: '1px'
  },

  heroOverlayBlue: {
    color: '#00a8ff'
  },

  overlayLine: {
    width: '70px',
    height: '3px',
    backgroundColor: '#ffffff',
    margin: '22px 0'
  },

  heroOverlaySubtitle: {
    margin: 0,
    fontSize: '19px',
    lineHeight: '1.4',
    fontWeight: '700',
    letterSpacing: '0.5px'
  },


  /* ==========================================================
     HERO FEATURES
     ========================================================== */

  heroFeatureBar: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    minHeight: '125px',
    backgroundColor: 'rgba(4,47,98,0.97)',
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    zIndex: 5,
    borderTop: '3px solid #0b8fe8'
  },

  heroFeature: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: '#ffffff',
    borderRight: '1px solid rgba(255,255,255,0.35)',
    fontSize: '13px',
    lineHeight: '1.3',
    fontWeight: '700',
    padding: '15px',
    transition: 'all 0.4s ease',
    cursor: 'default'
  },


  /* ==========================================================
     FACILITIES
     ========================================================== */

  facilitiesSection: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '57% 43%',
    backgroundColor: '#ffffff',
    boxSizing: 'border-box'
  },

  currentFacilities: {
    padding: '40px 35px 45px 45px',
    boxSizing: 'border-box'
  },

  sectionRibbon: {
    display: 'inline-block',
    backgroundColor: '#083c7a',
    color: '#ffffff',
    fontSize: '18px',
    fontWeight: '900',
    letterSpacing: '0.8px',
    padding: '13px 25px',
    borderRadius: '12px 12px 0 0',
    marginBottom: '20px'
  },

  facilityCards: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '20px'
  },

  facilityCard: {
    border: '1px solid #d7dce2',
    borderRadius: '14px',
    overflow: 'hidden',
    backgroundColor: '#ffffff',
    boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
    transition:
      'transform 0.45s cubic-bezier(.2,.8,.2,1), box-shadow 0.45s ease',
    cursor: 'pointer'
  },

  facilityImageArea: {
    height: '260px',
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: '#e8edf2'
  },

  facilityImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
    transition:
      'transform 0.8s cubic-bezier(.2,.8,.2,1)'
  },

  facilityIcon: {
    position: 'absolute',
    top: '14px',
    left: '14px',
    width: '52px',
    height: '52px',
    backgroundColor: '#06448d',
    color: '#ffffff',
    borderRadius: '9px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '28px',
    transition:
      'transform 0.4s ease, background-color 0.4s ease'
  },

  facilityContent: {
    padding: '20px'
  },

  facilityTitle: {
    margin: '0 0 8px 0',
    color: '#0756a5',
    fontSize: '21px',
    fontWeight: '900'
  },

  facilityDescription: {
    margin: 0,
    color: '#414b56',
    fontSize: '14px',
    lineHeight: '1.5'
  },


  /* ==========================================================
     MORE FACILITIES
     ========================================================== */

  moreFacilities: {
    backgroundColor: '#f8fafc',
    padding: '60px 50px',
    boxSizing: 'border-box',
    borderLeft: '1px solid #e1e5ea'
  },

  moreHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '15px',
    color: '#617080',
    fontSize: '17px',
    fontWeight: '700',
    letterSpacing: '1px'
  },

  headerLine: {
    width: '75px',
    height: '2px',
    backgroundColor: '#8291a2'
  },

  comingSoon: {
    margin: '8px 0 0 0',
    textAlign: 'center',
    color: '#0756a5',
    fontSize: '35px',
    lineHeight: 1,
    fontWeight: '900',
    letterSpacing: '1px'
  },

  moreGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    backgroundColor: '#ffffff',
    border: '1px solid #e0e4e8',
    borderRadius: '15px',
    overflow: 'hidden',
    boxShadow: '0 3px 12px rgba(0,0,0,0.05)'
  },

  comingItem: {
    minHeight: '150px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    borderRight: '1px solid #d9dee5',
    borderBottom: '1px solid #d9dee5',
    color: '#1e2b39',
    fontSize: '14px',
    lineHeight: '1.3',
    fontWeight: '800',
    padding: '15px',
    transition:
      'transform 0.4s ease, background-color 0.4s ease, box-shadow 0.4s ease',
    cursor: 'pointer'
  },

  comingIcon: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    color: '#073e7e',
    fontSize: '35px',
    marginBottom: '12px',
    transition:
      'transform 0.4s ease, color 0.3s ease'
  },


  /* ==========================================================
     WHY
     ========================================================== */

  whySection: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '58% 42%',
    backgroundColor: '#07366f',
    color: '#ffffff'
  },

  whyLeft: {
    padding: '35px',
    boxSizing: 'border-box'
  },

  whyTitle: {
    margin: '0 0 25px 0',
    textAlign: 'center',
    fontSize: '21px',
    fontWeight: '900',
    letterSpacing: '1px'
  },

  whyItems: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    gap: '5px'
  },

  whyItem: {
    minHeight: '110px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    borderRight: '1px solid rgba(255,255,255,0.35)',
    fontSize: '11px',
    lineHeight: '1.3',
    color: '#ffffff',
    padding: '5px',
    transition: 'transform 0.35s ease'
  },

  whyIcon: {
    width: '45px',
    height: '45px',
    borderRadius: '50%',
    border: '2px solid #ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '21px',
    marginBottom: '9px',
    transition:
      'transform 0.35s ease, background-color 0.35s ease, color 0.35s ease'
  },


  /* ==========================================================
     QUOTE
     ========================================================== */

  quoteBox: {
    position: 'relative',
    backgroundColor: '#064e9c',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 60px',
    boxSizing: 'border-box'
  },

  quoteText: {
    margin: 0,
    color: '#ffffff',
    fontSize: '20px',
    lineHeight: '1.55',
    fontWeight: '600',
    fontStyle: 'italic',
    textAlign: 'center'
  },

  quoteLeft: {
    position: 'absolute',
    top: '25px',
    left: '25px',
    fontSize: '38px',
    color: 'rgba(255,255,255,0.35)'
  },

  quoteRight: {
    position: 'absolute',
    bottom: '25px',
    right: '25px',
    fontSize: '38px',
    color: 'rgba(255,255,255,0.35)'
  },


  /* ==========================================================
     VISIT
     ========================================================== */

  visitSection: {
    width: '100%',
    minHeight: '145px',
    display: 'grid',
    gridTemplateColumns: '32% 40% 28%',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #d7dce2',
    boxSizing: 'border-box'
  },

  visitBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    padding: '25px 35px'
  },

  locationCircle: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: '#0756a5',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '30px',
    flexShrink: 0,
    transition: 'transform 0.4s ease'
  },

  visitTitle: {
    margin: 0,
    color: '#0756a5',
    fontSize: '18px',
    fontWeight: '900'
  },

  visitText: {
    margin: '5px 0 0 0',
    color: '#35404c',
    fontSize: '13px',
    lineHeight: '1.35'
  },

  visitCenter: {
    textAlign: 'center',
    padding: '20px',
    borderLeft: '1px solid #d5dbe2',
    borderRight: '1px solid #d5dbe2'
  },

  visitCenterSmall: {
    color: '#596777',
    fontSize: '14px',
    fontWeight: '700',
    letterSpacing: '1px'
  },

  visitCenterTitle: {
    margin: '7px 0 0 0',
    color: '#0756a5',
    fontSize: '25px',
    fontWeight: '900',
    letterSpacing: '1px'
  },

  socialBox: {
    textAlign: 'center',
    padding: '20px'
  },

  socialTitle: {
    margin: 0,
    color: '#182333',
    fontSize: '16px',
    fontWeight: '900'
  },

  socialIcons: {
    display: 'flex',
    justifyContent: 'center',
    gap: '9px',
    margin: '10px 0 6px 0'
  },

  socialIcon: {
    width: '34px',
    height: '34px',
    borderRadius: '50%',
    backgroundColor: '#0756a5',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    cursor: 'pointer',
    transition:
      'transform 0.3s ease, background-color 0.3s ease'
  },

  socialHandle: {
    color: '#0756a5',
    fontWeight: '800',
    fontSize: '13px'
  },


  /* ==========================================================
     FOOTER
     ========================================================== */

  footer: {
    width: '100%',
    minHeight: '125px',
    display: 'grid',
    gridTemplateColumns: '130px 330px 1fr',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    borderTop: '1px solid #ccd3dc',
    boxSizing: 'border-box'
  },

  footerNumber: {
    height: '100%',
    minHeight: '125px',
    backgroundColor: '#0756a5',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '75px',
    lineHeight: 1,
    fontWeight: '900',
    fontStyle: 'italic',
    clipPath: 'polygon(0 0, 100% 0, 82% 100%, 0 100%)'
  },

  footerCompany: {
    padding: '20px 25px'
  },

  footerCompanyTitle: {
    margin: 0,
    color: '#162433',
    fontSize: '19px',
    fontWeight: '900'
  },

  footerCompanyTag: {
    margin: '7px 0 0 0',
    color: '#2385d4',
    fontSize: '14px'
  },

  footerPillars: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    height: '100%'
  },

  footerPillar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    borderLeft: '1px solid #d4dae1',
    color: '#273544',
    fontSize: '9px',
    fontWeight: '800',
    lineHeight: '1.25',
    padding: '10px',
    transition:
      'background-color 0.3s ease, transform 0.3s ease'
  },

  footerPillarIcon: {
    color: '#0756a5',
    fontSize: '25px',
    marginBottom: '8px',
    transition: 'transform 0.35s ease'
  }

};


/* ============================================================
   ANIMATIONS + RESPONSIVE CSS
   ============================================================ */

if (typeof document !== 'undefined') {

  const styleId = 'rh-sports-arena-animation-styles';

  if (!document.getElementById(styleId)) {

    const style = document.createElement('style');

    style.id = styleId;

    style.innerHTML = `

      * {
        box-sizing: border-box;
      }

      html,
      body,
      #root {
        margin: 0 !important;
        padding: 0 !important;
        width: 100%;
        min-height: 100%;
      }

      body {
        overflow-x: hidden;
      }


      /* ======================================================
         ANIMATIONS
         ====================================================== */

      @keyframes rhFadeUp {

        from {
          opacity: 0;
          transform: translateY(35px);
        }

        to {
          opacity: 1;
          transform: translateY(0);
        }

      }


      @keyframes rhFadeRight {

        from {
          opacity: 0;
          transform: translateX(-35px);
        }

        to {
          opacity: 1;
          transform: translateX(0);
        }

      }


      @keyframes rhFadeLeft {

        from {
          opacity: 0;
          transform: translateX(35px);
        }

        to {
          opacity: 1;
          transform: translateX(0);
        }

      }


      @keyframes rhScaleIn {

        from {
          opacity: 0;
          transform: scale(0.94);
        }

        to {
          opacity: 1;
          transform: scale(1);
        }

      }


      @keyframes rhPulse {

        0% {
          transform: scale(1);
        }

        50% {
          transform: scale(1.08);
        }

        100% {
          transform: scale(1);
        }

      }


      @keyframes rhGlow {

        0%,
        100% {
          opacity: 0.15;
        }

        50% {
          opacity: 0.35;
        }

      }


      @keyframes rhShine {

        0% {
          transform: translateX(-120%);
        }

        100% {
          transform: translateX(120%);
        }

      }


      /* ======================================================
         HERO ENTRANCE
         ====================================================== */

      .rh-logo-area {
        animation:
          rhFadeRight 0.9s cubic-bezier(.2,.8,.2,1) both;
      }


      .rh-hero-left-content {
        animation:
          rhFadeRight 1s 0.15s cubic-bezier(.2,.8,.2,1) both;
      }


      .rh-hero-right {
        animation:
          rhFadeLeft 1s 0.1s cubic-bezier(.2,.8,.2,1) both;
      }


      .rh-hero-text {
        animation:
          rhFadeUp 1s 0.45s cubic-bezier(.2,.8,.2,1) both;
      }


      .rh-hero-feature {
        animation:
          rhFadeUp 0.7s cubic-bezier(.2,.8,.2,1) both;
      }


      .rh-hero-feature:nth-child(1) {
        animation-delay: 0.65s;
      }

      .rh-hero-feature:nth-child(2) {
        animation-delay: 0.75s;
      }

      .rh-hero-feature:nth-child(3) {
        animation-delay: 0.85s;
      }

      .rh-hero-feature:nth-child(4) {
        animation-delay: 0.95s;
      }


      /* ======================================================
         SMALL HERO LABEL
         ====================================================== */

      .rh-small-label {
        display: inline-block;
        color: #0756a5;
        font-size: 11px;
        font-weight: 900;
        letter-spacing: 2px;
        margin-bottom: 14px;
        position: relative;
      }

      .rh-small-label::after {
        content: "";
        display: inline-block;
        width: 28px;
        height: 2px;
        background: #0756a5;
        margin-left: 8px;
        vertical-align: middle;
      }


      /* ======================================================
         HERO BADGES
         ====================================================== */

      .rh-hero-badges {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 24px;
      }

      .rh-hero-badges span {
        padding: 7px 11px;
        border: 1px solid #d7e0ea;
        border-radius: 30px;
        color: #0756a5;
        background: #f7faff;
        font-size: 10px;
        font-weight: 800;
        letter-spacing: 0.7px;
        transition: all 0.3s ease;
      }

      .rh-hero-badges span:hover {
        background: #0756a5;
        color: #ffffff;
        border-color: #0756a5;
        transform: translateY(-3px);
        box-shadow: 0 6px 15px rgba(7,86,165,0.2);
      }


      /* ======================================================
         HERO IMAGE
         ====================================================== */

      .rh-hero-right:hover .rh-hero-image {
        transform: scale(1.07);
      }


      .rh-hero-right:hover .rh-hero-overlay {
        background:
          linear-gradient(
            135deg,
            rgba(2,17,34,0.91) 0%,
            rgba(2,17,34,0.30) 50%,
            rgba(2,17,34,0.65) 100%
          );
      }


      .rh-hero-overlay {
        transition: background 0.7s ease;
      }


      /* ======================================================
         HERO GLOW
         ====================================================== */

      .rh-hero-glow {
        position: absolute;
        width: 300px;
        height: 300px;
        right: -120px;
        top: -120px;
        border-radius: 50%;
        background: rgba(0,168,255,0.30);
        filter: blur(50px);
        pointer-events: none;
        animation: rhGlow 4s ease-in-out infinite;
      }


      .rh-hero-corner {
        position: absolute;
        width: 100px;
        height: 100px;
        right: 30px;
        top: 30px;
        border-top: 2px solid rgba(255,255,255,0.6);
        border-right: 2px solid rgba(255,255,255,0.6);
        opacity: 0.6;
        pointer-events: none;
      }


      .rh-hero-overline {
        font-size: 11px;
        font-weight: 800;
        letter-spacing: 2px;
        margin-bottom: 12px;
        color: rgba(255,255,255,0.85);
      }


      .rh-overlay-line {
        transition: width 0.6s ease;
      }


      .rh-hero-right:hover .rh-overlay-line {
        width: 110px !important;
      }


      /* ======================================================
         HERO FEATURES
         ====================================================== */

      .rh-hero-feature:hover {
        background-color: rgba(8,74,145,1) !important;
        transform: translateY(-5px);
      }


      .rh-feature-icon {
        font-size: 30px;
        color: #ffffff;
        margin-bottom: 10px;
        transition:
          transform 0.35s ease,
          color 0.35s ease;
      }


      .rh-hero-feature:hover .rh-feature-icon {
        transform: scale(1.22) rotate(5deg);
        color: #00a8ff;
      }


      /* ======================================================
         LOGO
         ====================================================== */

      .rh-sports-logo {
        transition:
          transform 0.5s ease,
          filter 0.5s ease;
      }


      .rh-sports-logo:hover {
        transform: scale(1.05);
        filter:
          drop-shadow(0 8px 15px rgba(7,86,165,0.18));
      }


      /* ======================================================
         SHORT LINE
         ====================================================== */

      .rh-hero-left:hover .rh-short-line {
        width: 110px !important;
      }


      /* ======================================================
         FACILITY SECTION
         ====================================================== */

      .rh-section-ribbon {
        transition:
          transform 0.35s ease,
          box-shadow 0.35s ease;
      }


      .rh-section-ribbon:hover {
        transform: translateX(5px);
        box-shadow: 0 8px 20px rgba(7,86,165,0.18);
      }


      /* ======================================================
         FACILITY CARD
         ====================================================== */

      .rh-facility-card {
        animation:
          rhScaleIn 0.8s cubic-bezier(.2,.8,.2,1) both;
      }


      .rh-facility-card:nth-child(2) {
        animation-delay: 0.12s;
      }


      .rh-facility-card:hover {
        transform: translateY(-11px);
        box-shadow:
          0 20px 40px rgba(0,0,0,0.18) !important;
      }


      .rh-facility-card:hover .rh-facility-image {
        transform: scale(1.10);
      }


      .rh-facility-card:hover .rh-facility-icon {
        transform: rotate(-7deg) scale(1.13);
        background-color: #0756a5;
      }


      .rh-image-shine {
        position: absolute;
        inset: 0;
        width: 45%;
        background:
          linear-gradient(
            100deg,
            transparent,
            rgba(255,255,255,0.35),
            transparent
          );
        transform: translateX(-130%);
        pointer-events: none;
      }


      .rh-facility-card:hover .rh-image-shine {
        animation: rhShine 0.9s ease;
      }


      .rh-card-label {
        position: absolute;
        right: 13px;
        top: 15px;
        padding: 6px 9px;
        border-radius: 4px;
        background: rgba(0,0,0,0.65);
        color: #ffffff;
        font-size: 9px;
        font-weight: 900;
        letter-spacing: 1px;
        backdrop-filter: blur(5px);
      }


      .rh-card-bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 16px;
        padding-top: 12px;
        border-top: 1px solid #e5e9ee;
        color: #0756a5;
        font-size: 9px;
        font-weight: 900;
        letter-spacing: 0.8px;
      }


      .rh-card-arrow {
        font-size: 20px;
        transition: transform 0.3s ease;
      }


      .rh-facility-card:hover .rh-card-arrow {
        transform: translateX(7px);
      }


      /* ======================================================
         COMING SOON
         ====================================================== */

      .rh-coming-description {
        margin: 12px 0 25px;
        text-align: center;
        color: #718096;
        font-size: 13px;
      }


      .rh-coming-item {
        position: relative;
        overflow: hidden;
      }


      .rh-coming-item:hover {
        transform: translateY(-7px);
        background-color: #f4f9ff !important;
        box-shadow:
          inset 0 0 0 1px #0b70c8;
        z-index: 2;
      }


      .rh-coming-item:hover .rh-coming-icon {
        transform: scale(1.16) rotate(5deg);
        color: #00a8ff;
      }


      .rh-coming-status {
        margin-top: 8px;
        font-size: 8px;
        color: #0756a5;
        opacity: 0;
        transform: translateY(5px);
        transition:
          opacity 0.3s ease,
          transform 0.3s ease;
        letter-spacing: 1px;
      }


      .rh-coming-item:hover .rh-coming-status {
        opacity: 1;
        transform: translateY(0);
      }


      /* ======================================================
         WHY SECTION
         ====================================================== */

      .rh-why-section {
        position: relative;
        overflow: hidden;
      }


      .rh-why-left {
        animation: rhFadeRight 0.9s ease both;
      }


      .rh-section-mini-title {
        text-align: center;
        color: #8fcfff;
        font-size: 10px;
        font-weight: 900;
        letter-spacing: 2px;
        margin-bottom: 7px;
      }


      .rh-why-item:hover {
        transform: translateY(-7px);
      }


      .rh-why-item:hover .rh-why-icon {
        transform: scale(1.15);
        background-color: #ffffff;
        color: #0756a5;
      }


      .rh-quote-box {
        animation: rhFadeLeft 0.9s ease both;
      }


      .rh-quote-box::before {
        content: "";
        position: absolute;
        inset: 20px;
        border: 1px solid rgba(255,255,255,0.13);
        pointer-events: none;
      }


      .rh-quote-icon {
        transition:
          transform 0.5s ease,
          color 0.4s ease;
      }


      .rh-quote-box:hover .rh-quote-left {
        transform: translateY(-5px);
      }


      /* ======================================================
         LOCATION
         ====================================================== */

      .rh-visit-box:hover .rh-location {
        transform: scale(1.1) rotate(-5deg);
      }


      .rh-location {
        box-shadow:
          0 8px 20px rgba(7,86,165,0.20);
      }


      /* ======================================================
         SOCIAL
         ====================================================== */

      .rh-social-icon:hover {
        transform: translateY(-5px) scale(1.08);
        background-color: #0b2545 !important;
        box-shadow:
          0 8px 18px rgba(7,86,165,0.25);
      }


      /* ======================================================
         FOOTER
         ====================================================== */

      .rh-footer-pillar:hover {
        background-color: #f3f8fd;
        transform: translateY(-4px);
      }


      .rh-footer-pillar:hover .rh-footer-icon {
        transform: scale(1.15) rotate(5deg);
      }


      /* ======================================================
         TABLET
         ====================================================== */

      @media (max-width: 1100px) {

        .rh-hero-left {
          padding: 45px 35px !important;
        }

        .rh-hero-right {
          min-height: 560px !important;
        }

        .rh-hero-text {
          left: 45px !important;
        }

        .rh-sports-logo {
          width: 230px !important;
        }

        .rh-hero-overlay-title {
          font-size: 36px !important;
        }

        .rh-more-facilities {
          padding: 45px 30px !important;
        }

        .rh-current-facilities {
          padding-left: 30px !important;
        }

      }


      /* ======================================================
         900 PX
         ====================================================== */

      @media (max-width: 900px) {

        .rh-hero-section {
          min-height: auto !important;
        }

        .rh-hero-left {
          width: 40% !important;
        }

        .rh-hero-right {
          width: 60% !important;
        }

        .rh-hero-headline {
          font-size: 32px !important;
        }

        .rh-facility-cards {
          grid-template-columns: 1fr !important;
        }

        .rh-facility-image-area {
          height: 250px !important;
        }

        .rh-footer {
          grid-template-columns: 100px 260px 1fr !important;
        }

        .rh-footer-pillars {
          grid-template-columns: repeat(5, 1fr) !important;
        }

      }


      /* ======================================================
         MOBILE 768
         ====================================================== */

      @media (max-width: 768px) {

        .rh-hero-section {
          display: block !important;
        }


        .rh-hero-left {
          width: 100% !important;
          min-height: auto !important;
          padding: 40px 28px !important;
        }


        .rh-hero-right {
          width: 100% !important;
          min-height: 560px !important;
        }


        .rh-sports-logo {
          width: 240px !important;
          max-width: 80% !important;
        }


        .rh-hero-left-content {
          margin-top: 35px !important;
        }


        .rh-hero-text {
          left: 30px !important;
          top: 40px !important;
          right: 20px !important;
        }


        .rh-hero-overlay-title {
          font-size: 34px !important;
        }


        .rh-hero-feature-bar {
          grid-template-columns: repeat(2, 1fr) !important;
        }


        .rh-hero-feature {
          min-height: 85px !important;
          font-size: 10px !important;
        }


        .rh-feature-icon {
          font-size: 24px !important;
          margin-bottom: 6px !important;
        }


        .facilitiesSection {
          display: block !important;
        }


        .rh-current-facilities {
          padding: 30px 20px !important;
        }


        .rh-facility-cards {
          grid-template-columns: 1fr !important;
        }


        .rh-facility-image-area {
          height: 280px !important;
        }


        .rh-more-facilities {
          padding: 40px 20px !important;
        }


        .rh-more-grid {
          grid-template-columns: repeat(2, 1fr) !important;
        }


        .rh-coming-item {
          min-height: 135px !important;
        }


        .rh-why-section {
          display: block !important;
        }


        .rh-why-left {
          padding: 35px 20px !important;
        }


        .rh-why-items {
          grid-template-columns: repeat(2, 1fr) !important;
          gap: 8px !important;
        }


        .rh-why-item {
          border: 1px solid rgba(255,255,255,0.22) !important;
          border-radius: 8px;
        }


        .rh-quote-box {
          min-height: 260px !important;
          padding: 45px 45px !important;
        }


        .rh-quote-box::before {
          inset: 15px !important;
        }


        .rh-visit-section {
          display: block !important;
        }


        .rh-visit-box,
        .rh-visit-center,
        .rh-social-box {
          width: 100% !important;
          border-left: none !important;
          border-right: none !important;
          border-bottom: 1px solid #d5dbe2;
        }


        .rh-footer {
          display: block !important;
        }


        .rh-footer-number {
          min-height: 90px !important;
          height: 90px !important;
          clip-path: none !important;
        }


        .rh-footer-pillars {
          grid-template-columns: repeat(2, 1fr) !important;
        }

      }


      /* ======================================================
         MOBILE 600
         ====================================================== */

      @media (max-width: 600px) {

        .topNav {
          padding: 12px !important;
        }


        .backButton {
          font-size: 12px !important;
          padding: 10px 14px !important;
        }


        .rh-hero-left {
          padding: 35px 22px !important;
        }


        .rh-sports-logo {
          width: 210px !important;
          max-width: 85% !important;
        }


        .rh-small-label {
          font-size: 9px !important;
          letter-spacing: 1.5px !important;
        }


        .rh-hero-left-content h1,
        .rh-hero-left-content h2 {
          font-size: 31px !important;
        }


        .rh-hero-description {
          font-size: 15px !important;
          line-height: 1.6 !important;
        }


        .rh-hero-right {
          min-height: 510px !important;
        }


        .rh-hero-text {
          left: 23px !important;
          top: 30px !important;
        }


        .rh-hero-overlay-title {
          font-size: 28px !important;
        }


        .rh-hero-overlay-subtitle {
          font-size: 13px !important;
        }


        .rh-hero-overline {
          font-size: 8px !important;
          letter-spacing: 1.4px !important;
        }


        .rh-hero-corner {
          width: 60px !important;
          height: 60px !important;
          right: 15px !important;
          top: 15px !important;
        }


        .rh-hero-feature-bar {
          grid-template-columns: repeat(2, 1fr) !important;
        }


        .rh-hero-feature {
          min-height: 75px !important;
          padding: 8px !important;
          font-size: 9px !important;
        }


        .rh-feature-icon {
          font-size: 21px !important;
        }


        .rh-section-ribbon {
          font-size: 14px !important;
          padding: 11px 17px !important;
        }


        .rh-facility-image-area {
          height: 230px !important;
        }


        .rh-facility-content {
          padding: 17px !important;
        }


        .rh-facility-title {
          font-size: 19px !important;
        }


        .rh-facility-description {
          font-size: 13px !important;
        }


        .rh-more-facilities {
          padding: 35px 15px !important;
        }


        .rh-more-grid {
          grid-template-columns: repeat(2, 1fr) !important;
        }


        .rh-coming-item {
          min-height: 125px !important;
          font-size: 12px !important;
          padding: 10px !important;
        }


        .rh-coming-icon {
          width: 48px !important;
          height: 48px !important;
          font-size: 27px !important;
          margin-bottom: 8px !important;
        }


        .rh-coming-status {
          font-size: 7px !important;
        }


        .rh-coming-description {
          font-size: 12px !important;
        }


        .rh-why-title {
          font-size: 18px !important;
        }


        .rh-why-item {
          min-height: 105px !important;
          font-size: 10px !important;
        }


        .rh-quote-text {
          font-size: 17px !important;
        }


        .rh-visit-box {
          padding: 25px 20px !important;
          justify-content: center;
        }


        .rh-visit-center-title {
          font-size: 21px !important;
        }


        .rh-footer-company {
          padding: 25px 20px !important;
          text-align: center;
        }


        .rh-footer-pillars {
          grid-template-columns: repeat(2, 1fr) !important;
        }

      }


      /* ======================================================
         SMALL MOBILE
         ====================================================== */

      @media (max-width: 400px) {

        .rh-sports-logo {
          width: 185px !important;
        }


        .rh-hero-left-content h1,
        .rh-hero-left-content h2 {
          font-size: 28px !important;
        }


        .rh-hero-description {
          font-size: 14px !important;
        }


        .rh-hero-right {
          min-height: 480px !important;
        }


        .rh-hero-overlay-title {
          font-size: 25px !important;
        }


        .rh-hero-overlay-subtitle {
          font-size: 11px !important;
        }


        .rh-more-grid {
          grid-template-columns: 1fr 1fr !important;
        }


        .rh-coming-item {
          min-height: 115px !important;
        }


        .rh-coming-icon {
          width: 43px !important;
          height: 43px !important;
          font-size: 24px !important;
        }


        .rh-why-items {
          grid-template-columns: 1fr 1fr !important;
        }


        .rh-quote-box {
          padding: 40px 30px !important;
        }


        .rh-quote-text {
          font-size: 15px !important;
        }

      }


      /* ======================================================
         REDUCED MOTION
         ====================================================== */

      @media (prefers-reduced-motion: reduce) {

        *,
        *::before,
        *::after {
          animation-duration: 0.01ms !important;
          animation-iteration-count: 1 !important;
          transition-duration: 0.01ms !important;
          scroll-behavior: auto !important;
        }

      }

    `;

    document.head.appendChild(style);

  }

}